import { render, staticRenderFns } from "./dooh-delivery.vue?vue&type=template&id=79c4709e&scoped=true"
import script from "./dooh-delivery.vue?vue&type=script&lang=js"
export * from "./dooh-delivery.vue?vue&type=script&lang=js"
import style0 from "./dooh-delivery.vue?vue&type=style&index=0&id=79c4709e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c4709e",
  null
  
)

export default component.exports